<template>
<div  style="width: 100%;">

    <el-menu mode="horizontal"
             background-color="transparent"
             text-color="#000"
             :default-active="activeIndex"
             text-size="0.95vw"
             style="width: 100%;">
        <template v-for="(value, index) in this.MenuList">
            <el-menu-item style="width:7.18vw;height: 3.49vw;display: flex;justify-content: center;align-items: center;font-size: 0.96vw;"
                          :index="value.ID+''" @click="toLink(value.Url, value.Target)">
                {{ value.Name }}
                <div class="section_4 flex-col" id="business" v-if="value.ID=='3'" style="background-color: white; position: absolute; top: 3.5vw;padding: 1vw;">
                    <div class="flex-row">
                        <div v-for="(item) in Product" style="width: 12vw;">
                            <div style="width:100%">
                                <div class="group_20 flex-col" style="float: left;"></div>
                                <span class="text_59" style="float: left">{{item.label}}</span>
                            </div>
                            <div v-for="(sub) in item.children" class="text_41" :style="{color:tpid==sub.id?'rgba(0, 90, 214, 1)':'black'}" @click="toLink('/Client/Business/Product?tpid='+sub.id+'&tid=&id=', '')">{{sub.label}}</div>
                        </div>
                    </div>
                </div>
                <div class="section_4 flex-col" id="business" v-if="value.ID=='4'" style="background-color: white; position: absolute; top: 3.5vw;padding: 1vw;">
                    <div class="flex-row">
                        <div v-for="(item) in Solution" style="width: 12vw;">
                            <div style="width:100%">
                                <div class="group_20 flex-col" style="float: left;"></div>
                                <span class="text_59" style="float: left">{{item.label}}</span>
                            </div>
                            <div v-for="(sub) in item.children" class="text_41" :style="{color:tpid==sub.id?'rgba(0, 90, 214, 1)':'black'}" @click="toLink('/Client/Business/Solution?tpid='+sub.id+'&tid=&id=', '')">{{sub.label}}</div>
                        </div>
                    </div>
                </div>
            </el-menu-item>
        </template>
    </el-menu>
</div>
</template>
<script>

import menuRedirect from "../../../router/menuRedirect";
    export default{
        name: "HorizontalMenu",
        data(){
            return{
                activeIndex: '1',
                MenuList:[ { ID: '1', Url:"/Client/Index",Target:"",Name:"网站首页"},
                    { ID:'2',Url:"/Client/AboutSailHero/index",Target:"",Name:"关于先河"},
                    { ID: '3', Url: "#", Target: "", Name: "产品中心" },
                    { ID: '4', Url:"#",Target:"",Name:"解决方案"},
                    {ID:'5',Url:"/Client/NewsTrends",Target:"",Name:"新闻动态"},
                    // {ID:'6',Url:"/Client/PartyWork",Target:"",Name:"党务建设"},
                    {ID:'7',Url:"/Client/InvestorRelations",Target:"",Name:"投资者关系"},
                    // {ID:'8',Url:"/Client/HumanResources/index",Target:"",Name:"人力资源"},
                    { ID: '9', Url:"/Client/Member",Target:"",Name:"分子公司"},
                    {ID:'10',Url:"/Client/ContactUs/index",Target:"",Name:"联系我们"}
                ],
                MenuIDList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                Product: [],
                Solution: [],
                tpid:""
            }
        },
        methods:{
            toLink(path, target) {
                this.$parent.setLoading(false);
                if (path && path != "#") {
                    switch (target) {
                        case "main":
                            if (!path.startsWith("#"))
                                this.$router.push(path);
                            break;
                        case "_blank":
                            window.open(path, "_blank");
                            break;
                        default:
                            this.$router.push(path);
                            break;
                    }
                }
            },
            getDataTree(businessType) {
                let that = this;
                that.$api.post("/Client/getBusinessDataTree", { businessType: businessType },
                    function (res) {
                        that.data = [];
                        if (res.code === "200") {
                            if (businessType == "产品中心") {
                                that.Product = res.data;
                            }
                            else {
                                that.Solution = res.data;
                            }
                        }
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            },
            setActiveIndex(index) { this.activeIndex = index; }
        },
        mounted(){
            this.activeIndex = this.$route.meta.menuid;
            if (this.$route.query.tpid) { this.tpid = this.$route.query.tpid; }
        },
        created() { this.getDataTree("产品中心"); this.getDataTree("解决方案"); },
        watch:{
            $route:{
                handler(val,oldval){
                    if (this.MenuIDList.indexOf(val.meta.menuid) > -1){
                        this.activeIndex = val.meta.menuid;
                    }
                    if (this.$route.query.tpid) { this.tpid = this.$route.query.tpid; }
               },
                deep:true
            }
        },
    }
</script>
<style scoped>
    .el-menu--horizontal>.el-menu-item.is-active {
        border-bottom:0.22vw solid #0057C1;
        color:#0057C1
    }
    .el-menu-item:hover{
        background-color: transparent !important;
    }
    .el-menu-item.is-active {
        border-bottom-color:#0057C1!important;
        background-color: transparent !important;
        font-weight:900 !important;
        color: #0057C1 !important;
    }
    .el-menu-item:hover #business {
        display: block;
    }
    #business {
        display:none;
    .section_4
    {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 4px;
        height: 20.11vw;
        width: 31.57vw;
        position: absolute;
        left: 26.72vw;
        top: 4vw;
        opacity: 1;
    }

    .text-wrapper_11 {
        width: 27.92vw;
        height: 0.94vw;
        margin: 3.02vw 0 0.45vw 1.56vw;
    }

    .text_41 {
        clear: both;
        width: 12vw;
        height: 0.94vw;
        overflow-wrap: break-word;
        font-size: 0.85vw;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.94vw;
        cursor: pointer;
        padding: 1vw 0.7vw 1vw 0.7vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .group_20 {
        background-color: rgba(0, 90, 214, 1);
        border-radius: 2px;
        width: 0.21vw;
        height: 0.94vw;
    }

    .text_59 {
        width: 10.75vw;
        height: 0.94vw;
        overflow-wrap: break-word;
        color: rgba(0, 90, 214, 1);
        font-size: 0.93vw;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 0.94vw;
        margin-left: 0.53vw;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
    }
    }
</style>
